import { createSelector } from '@reduxjs/toolkit';
import { selfSelector } from '../self';

const sourcesSelector = createSelector(selfSelector, (clients) => clients.sources);

export default sourcesSelector;
